import {
  jb_button_primary_css_default
} from "./chunk.XWACWWNE.js";
import {
  i as i2,
  u
} from "./chunk.MG3UUVYL.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  Linkable
} from "./chunk.534YP5ZJ.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ButtonElement
} from "./chunk.ALE4QRAM.js";
import {
  A,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-button-primary/jb-button-primary.ts
var JbButtonPrimary = class extends Initiable(ButtonElement(Linkable(i))) {
  render() {
    const classes = { inactive: !!this.inactive, hover: !!this.forceHover, inverted: !!this.inverted };
    const tag = this.link?.href ? i2`a data-linkable` : i2`button`;
    return u`<${tag} part="action" class=${e(classes)} ?disabled=${this.inactive} data-fly-tweak="3,0,0,0"><slot>${this.text ? o(this.text) : A}</slot></${tag}>`;
  }
};
JbButtonPrimary.styles = [reset_css_default, jb_button_primary_css_default];
JbButtonPrimary.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbButtonPrimary.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonPrimary.prototype, "inactive", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonPrimary.prototype, "inverted", 2);
__decorateClass([
  n({ type: Object })
], JbButtonPrimary.prototype, "link", 2);
__decorateClass([
  n()
], JbButtonPrimary.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonPrimary.prototype, "text", 2);
JbButtonPrimary = __decorateClass([
  customElement("jb-button-primary")
], JbButtonPrimary);

export {
  JbButtonPrimary
};
